import { Navigate } from "react-router-dom";

const AdminGuard = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  const role = localStorage.getItem("admin_role");

  if (!token || !role) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminGuard;
